module.exports = __webpack_public_path__ + "img/10.29d84191.jpg";